import React from "react"; 

export default function SmsSendModal({ item, close }) {
  return (
    <React.Fragment>
      <div className="location_modal text-right" style={{direction:"rtl"}}>
        <div className="location_modal_box">
          <div className="location_modal_header bg-dark p-2">
            <span className=" w-100 text-right text-white">مشاهده جزییات</span>
          </div>
          <div className="p-4 text-center">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>ip</span>
              <span>{item.ip}</span>
            </div>
            <hr/>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>الگو</span>
              <span>{item.template_id}</span>
            </div>
            <hr/>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>شماره موبایل</span>
              <span>{item.receiver}</span>
            </div>
            <hr/>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span> پیام  </span>
              <span>{item.message_content}</span>
            </div>
            <hr/>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>کد یکتانت</span>
              <span>{item.code}</span>
            </div>
            <hr/>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span> پیام خطا</span>
              <code>{item.error_message}</code>
            </div>
            <hr/>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span> پیام ارسال</span>
              <code>{item.result_message}</code>
            </div>
            <div className="row text-right my-3 " style={{ direction: "rtl" }}>
              <div className="col-12 text-center">
                <button className="btn btn-danger btn-block" onClick={close}>
                  بستن
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
